"use strict";

/* eslint-disable react/jsx-handler-names */
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Board = _interopRequireDefault(require("./Board"));

var _Preview = _interopRequireDefault(require("./Preview"));

var _Ribbon = _interopRequireDefault(require("./Ribbon"));

var _Alpha = _interopRequireDefault(require("./Alpha"));

var _Params = _interopRequireDefault(require("./Params"));

var _Favorites = _interopRequireDefault(require("./Favorites"));

var Panel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Panel, _React$Component);

  function Panel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Panel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Panel).call(this, props));
    var events = ['onFocus', 'onBlur', 'onSystemColorPickerOpen']; // bind methods

    events.forEach(function (m) {
      _this[m] = _this[m].bind((0, _assertThisInitialized2.default)(_this));
    });
    return _this;
  }

  (0, _createClass2.default)(Panel, [{
    key: "onSystemColorPickerOpen",
    value: function onSystemColorPickerOpen(e) {
      // only works with browsers that support color input
      if (e.target.type === 'color') {
        this.systemColorPickerOpen = true;
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      if (this._blurTimer) {
        clearTimeout(this._blurTimer);
        this._blurTimer = null;
      } else {
        this.props.onFocus();
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      var _this2 = this;

      if (this._blurTimer) {
        clearTimeout(this._blurTimer);
      }

      this._blurTimer = setTimeout(function () {
        // if is system color picker open, then stop run blur
        if (_this2.systemColorPickerOpen) {
          _this2.systemColorPickerOpen = false;
          return;
        }

        _this2.props.onBlur();
      }, 100);
    }
  }, {
    key: "renderAlpha",
    value: function renderAlpha(_ref) {
      var alpha = _ref.alpha,
          alphaClassName = _ref.alphaClassName,
          hex = _ref.hex,
          includeAlpha = _ref.includeAlpha,
          onChange = _ref.onChange;
      if (!includeAlpha) return null;
      return _react.default.createElement(_Alpha.default, {
        alpha: alpha,
        className: alphaClassName,
        hex: hex,
        onChange: onChange
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alpha = _this$props.alpha,
          alphaClassName = _this$props.alphaClassName,
          boardClassName = _this$props.boardClassName,
          className = _this$props.className,
          colorsClassName = _this$props.colorsClassName,
          favorites = _this$props.favorites,
          fieldsetSize = _this$props.fieldsetSize,
          hex = _this$props.hex,
          hexOnly = _this$props.hexOnly,
          hue = _this$props.hue,
          includeAlpha = _this$props.includeAlpha,
          mode = _this$props.mode,
          onChange = _this$props.onChange,
          ribbonClassName = _this$props.ribbonClassName,
          style = _this$props.style;
      var classes = (0, _classNames.default)(className, 'private-react-colorpicker');
      return _react.default.createElement("div", {
        className: classes,
        style: style,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        tabIndex: "0"
      }, _react.default.createElement("div", {
        className: (0, _classNames.default)('private-react-colorpicker--colors', colorsClassName)
      }, _react.default.createElement(_Board.default, {
        className: boardClassName,
        hex: hex,
        hue: hue,
        onChange: onChange
      }), _react.default.createElement("div", {
        className: "private-react-colorpicker--ribbon-wrapper"
      }, _react.default.createElement("div", {
        className: "private-react-colorpicker--ribbons"
      }, _react.default.createElement(_Ribbon.default, {
        hue: hue,
        onChange: onChange,
        className: ribbonClassName
      }), this.renderAlpha({
        alpha: alpha,
        alphaClassName: alphaClassName,
        hex: hex,
        includeAlpha: includeAlpha,
        onChange: onChange
      })), _react.default.createElement(_Preview.default, {
        alpha: alpha,
        hex: hex,
        onChange: onChange,
        onInputClick: this.onSystemColorPickerOpen
      })), _react.default.createElement(_Favorites.default, {
        onSelectColor: onChange,
        favorites: favorites
      })), _react.default.createElement(_Params.default, {
        hexOnly: hexOnly,
        includeAlpha: includeAlpha,
        alpha: alpha,
        fieldsetSize: fieldsetSize,
        hex: hex,
        hue: hue,
        onChange: onChange,
        mode: mode
      }));
    }
  }]);
  return Panel;
}(_react.default.Component);

exports.default = Panel;
Panel.propTypes = {
  alpha: _react.PropTypes.number,
  alphaClassName: _react.PropTypes.string,
  boardClassName: _react.PropTypes.string,
  className: _react.PropTypes.string,
  colorsClassName: _react.PropTypes.string,
  favorites: _react.PropTypes.array,
  fieldsetSize: _Params.default.propTypes.fieldsetSize,
  hex: _react.PropTypes.string,
  hexOnly: _react.PropTypes.bool,
  hue: _react.PropTypes.number,
  includeAlpha: _react.PropTypes.bool,
  mode: _react.PropTypes.oneOf(['RGB', 'HSL', 'HSB']),
  onBlur: _react.PropTypes.func,
  onChange: _react.PropTypes.func,
  onFocus: _react.PropTypes.func,
  ribbonClassName: _react.PropTypes.string,
  style: _react.PropTypes.object
};
module.exports = exports.default;